import { Injectable } from '@angular/core';
import { BaseWsService } from '../../../../core/services/BaseWsService';
import { IWebSocketResponse } from '../../../../core/interfaces/IWebSocketResponse';
import { TerminalWsMethods } from '../enums/TerminalWsMethods';
import { ICardActionLog } from '../../../cart/core/interfaces/ICardActionLog';
import { IWorkerConnectionStatus } from '../../../worker/core/interfaces/IWorkerConnectionStatus';

@Injectable({
  providedIn: 'root'
})
export class TerminalWsService extends BaseWsService {

  protected override readonly hubUrl = '/terminal';
  protected override readonly invokeArguments = [this.terminalsStore.selectedTerminal().id];

  public onCardActionStatusChanged(method: (payload: IWebSocketResponse<ICardActionLog>) => void): void {
    this.createMethod(TerminalWsMethods.EcTerminalStatusChanged, method);
  }

  public onWorkerStatusChanged(method: (payload: IWebSocketResponse<IWorkerConnectionStatus>) => void): void {
    this.createMethod(TerminalWsMethods.WorkerStatusChanged, method);
  }
}
